import React from 'react';
import { PreferencesProvider } from './context/PreferencesContext';
import { PermissionProvider } from './context/PermissionContext';
import SessionTimeoutManager from './components/SessionTimeoutManager';
import Routes from './Routes';

function App() {
  return (
    <PreferencesProvider>
      <PermissionProvider>
        <SessionTimeoutManager />
        <Routes />
      </PermissionProvider>
    </PreferencesProvider>
  );
}

export default App;